// Browsing history of home detail pages, kept per browser in localStorage (newest first).
// Written on /homes/:id (packs/web/homes/viewed.js), read on the official top page
// (packs/official/index.js) to render the "閲覧履歴" row. Ids are the homes' numeric ids, kept as strings.
const STORAGE_KEY = 'address.viewedHomeIds'
const MAX_STORED = 20

function readViewedHomeIds() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string' && id !== '') : []
  } catch (e) {
    return []
  }
}

function recordViewedHome(id) {
  if (!id) return
  try {
    const ids = [id, ...readViewedHomeIds().filter((stored) => stored !== id)].slice(0, MAX_STORED)
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
  } catch (e) {
    // Storage may be unavailable (private mode, quota); browsing history is a nicety, so ignore.
  }
}

export { readViewedHomeIds, recordViewedHome }
